// Core Imports
import React from 'react';
import Slider from "react-slick";

// Styles for Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Asset Imports
import Vehicle3 from '../assets/images/vehicle-3.svg';
import Vehicle4 from '../assets/images/vehicle-4.svg';
import Vehicle5 from '../assets/images/vehicle-5.svg';
import Vehicle6 from '../assets/images/vehicle-6.svg';
import Vehicle7 from '../assets/images/vehicle-7.svg';
import Vehicle8 from '../assets/images/vehicle-8.svg';

const Machinery = () => {
  // Slider configuration settings
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Array of machinery items to render dynamically
  const machineryItems = [
    { image: Vehicle3, count: 54, label: 'Tipper' },
    { image: Vehicle4, count: 26, label: 'Transit Mixer' },
    { image: Vehicle5, count: 8, label: 'Front Wheel Loader' },
    { image: Vehicle6, count: 4, label: 'Excavator' },
    { image: Vehicle7, count: 14, label: 'Tractor Loader / Trolley' },
    { image: Vehicle8, count: 7, label: 'JCB Backhoe Loader' }
  ];

  return (
    <div className="text-center">
      <Slider {...settings}>
        {machineryItems.map((item, index) => (
          <div className="machinery" key={index}>
            <img src={item.image} alt={item.label} className="img-fluid" />
            <div className="count">
              <h4><span>{item.count}</span> {item.label}</h4>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Machinery;
